import { ResponseError } from '@backstage/errors';
import { GitManager } from './git/gitManager.esm.js';

class VeeClient {
  constructor(configApi, fetchApi, githubAuthApi, gitlabAuthApi) {
    this.configApi = configApi;
    this.fetchApi = fetchApi;
    this.githubAuthApi = githubAuthApi;
    this.gitlabAuthApi = gitlabAuthApi;
  }
  async fetch(input, init) {
    const baseUrl = `${this.configApi.getString("backend.baseUrl")}/api/vee`;
    const response = await this.fetchApi.fetch(`${baseUrl}${input}`, {
      ...init
    });
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
  async getGitManager() {
    return new GitManager(this.configApi, this.githubAuthApi, this.gitlabAuthApi);
  }
  async cloneRepo(location) {
    const body = {
      location
    };
    const gitManager = await this.getGitManager();
    const token = await gitManager.getAccessToken(location);
    const headers = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        "Git-Authorization": `Bearer ${token}`
      }
    };
    const response = await this.fetch("/clone-repository", headers);
    return {
      files: response.data.files,
      structure: response.data.structure
    };
  }
  async submitRepo(engine = "openAI", files, repoName) {
    const body = {
      engine,
      repoName,
      files
    };
    const headers = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await this.fetch("/submit-repo", headers);
    return response;
  }
  async createAssistant(engine = "openAI", vectorStoreId, prompt, repoName, repoStructure) {
    const body = {
      engine,
      vectorStoreId,
      prompt,
      repoName,
      repoStructure
    };
    const headers = {
      method: "POST",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await this.fetch("/chat-analyze-repo", headers);
    return response;
  }
  async getChat(engine = "openAI", vectorStoreId, prompt, repoName, repoStructure) {
    const response = await this.createAssistant(engine, vectorStoreId, prompt, repoName, repoStructure);
    return response;
  }
  async clearHistory(engine = "openAI", vectorStoreId, assistantId, threadId) {
    const body = {
      engine,
      vectorStoreId,
      assistantId,
      threadId
    };
    const headers = {
      method: "DELETE",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await this.fetch("/chat-analyze-repo", headers);
    return response;
  }
  async saveChangesInRepository(files, location, title, message) {
    const gitManager = await this.getGitManager();
    return gitManager.createPullRequest(
      files,
      location,
      title,
      message
    );
  }
}

export { VeeClient };
//# sourceMappingURL=veeClient.esm.js.map
